if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

// =============================================
// Quick View: close modal when mouse moves outside the panel
// =============================================
// The modal element is a full-screen overlay so we watch the inner
// visible panel (.quick-add-modal__content) for mouseleave instead.
(function () {
  const _qaObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName !== 'open') return;
      const modal = mutation.target;
      if (!(modal instanceof Element) || !modal.matches('quick-add-modal')) return;

      if (modal.hasAttribute('open')) {
        // Wait one tick for the content to be injected by show()
        requestAnimationFrame(function () {
          const panel = modal.querySelector('.quick-add-modal__content');
          if (!panel || panel._qaHoverBound) return;
          panel._qaHoverBound = true;

          panel.addEventListener('mouseleave', function () {
            clearTimeout(modal._qaCloseTimer);
            modal._qaCloseTimer = setTimeout(function () {
              if (modal.hasAttribute('open')) modal.hide();
            }, 250);
          });

          panel.addEventListener('mouseenter', function () {
            clearTimeout(modal._qaCloseTimer);
          });
        });
      } else {
        // Modal closed — reset bound flag so it works next time
        const panel = modal.querySelector('.quick-add-modal__content');
        if (panel) panel._qaHoverBound = false;
      }
    });
  });

  _qaObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  });
})();

// =============================================
// Quick View: More Details link → navigate to PDP
// =============================================
document.addEventListener('click', function(e) {
  // Handle "More Details" link inside quick view modal
  const target = e.target.closest('.more_desc');
  if (!target) return;

  const modal = target.closest('quick-add-modal');
  if (!modal) return;

  // Find the product URL from the product title link or opener
  const titleLink = modal.querySelector('.product__title > a');
  if (titleLink && titleLink.href && !titleLink.href.endsWith('#')) {
    e.preventDefault();
    window.location.href = titleLink.href;
    return;
  }

  // Fallback: get URL from the modal opener's data-product-url
  const opener = modal.openedBy;
  if (opener) {
    const productUrl = opener.getAttribute('data-product-url');
    if (productUrl) {
      e.preventDefault();
      window.location.href = productUrl;
    }
  }
});